/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WheelDetails } from './WheelDetails';
import {
    WheelDetailsFromJSON,
    WheelDetailsFromJSONTyped,
    WheelDetailsToJSON,
} from './WheelDetails';
import type { LoyaltyRedemptionStatus } from './LoyaltyRedemptionStatus';
import {
    LoyaltyRedemptionStatusFromJSON,
    LoyaltyRedemptionStatusFromJSONTyped,
    LoyaltyRedemptionStatusToJSON,
} from './LoyaltyRedemptionStatus';
import type { S2WGame } from './S2WGame';
import {
    S2WGameFromJSON,
    S2WGameFromJSONTyped,
    S2WGameToJSON,
} from './S2WGame';

/**
 * 
 * @export
 * @interface SpinWithFullGame
 */
export interface SpinWithFullGame {
    /**
     * The id of the most recent assignment attempt. Present whenever an attempt was made.
     * If status=PENDING, pass this back in a subsequent redeemReward call to retry.
     * @type {string}
     * @memberof SpinWithFullGame
     */
    playerRewardAttemptId?: string | null;
    /**
     * The id of the reward this redemption produced. Present whenever an attempt was made.
     * @type {string}
     * @memberof SpinWithFullGame
     */
    playerRewardId?: string | null;
    /**
     * Text details of the redemption. If a redemption is pending this will be null/undefined. If a redemption is complete, this will be
     * the textual representation of the reward, like "$10 Coupon". If the redemption failed this will be the text of the error
     * message like "Insufficient point balance".
     * @type {string}
     * @memberof SpinWithFullGame
     */
    details?: string | null;
    /**
     * 
     * @type {LoyaltyRedemptionStatus}
     * @memberof SpinWithFullGame
     */
    status: LoyaltyRedemptionStatus;
    /**
     * 
     * @type {Date}
     * @memberof SpinWithFullGame
     */
    resolvedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SpinWithFullGame
     */
    createdAt: Date;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof SpinWithFullGame
     */
    playerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof SpinWithFullGame
     */
    customerId: string;
    /**
     * 
     * @type {WheelDetails}
     * @memberof SpinWithFullGame
     */
    wheelDetails?: WheelDetails | null;
    /**
     * 
     * @type {S2WGame}
     * @memberof SpinWithFullGame
     */
    game: S2WGame;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof SpinWithFullGame
     */
    id: string;
}



/**
 * Check if a given object implements the SpinWithFullGame interface.
 */
export function instanceOfSpinWithFullGame(value: object): value is SpinWithFullGame {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('game' in value) || value['game'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SpinWithFullGameFromJSON(json: any): SpinWithFullGame {
    return SpinWithFullGameFromJSONTyped(json, false);
}

export function SpinWithFullGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWithFullGame {
    if (json == null) {
        return json;
    }
    return {
        
        'playerRewardAttemptId': json['playerRewardAttemptId'] == null ? undefined : json['playerRewardAttemptId'],
        'playerRewardId': json['playerRewardId'] == null ? undefined : json['playerRewardId'],
        'details': json['details'] == null ? undefined : json['details'],
        'status': LoyaltyRedemptionStatusFromJSON(json['status']),
        'resolvedAt': json['resolvedAt'] == null ? undefined : (new Date(json['resolvedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'playerId': json['playerId'],
        'customerId': json['customerId'],
        'wheelDetails': json['wheelDetails'] == null ? undefined : WheelDetailsFromJSON(json['wheelDetails']),
        'game': S2WGameFromJSON(json['game']),
        'id': json['id'],
    };
}

export function SpinWithFullGameToJSON(value?: SpinWithFullGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'playerRewardAttemptId': value['playerRewardAttemptId'],
        'playerRewardId': value['playerRewardId'],
        'details': value['details'],
        'status': LoyaltyRedemptionStatusToJSON(value['status']),
        'resolvedAt': value['resolvedAt'] == null ? undefined : ((value['resolvedAt'] as any).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'playerId': value['playerId'],
        'customerId': value['customerId'],
        'wheelDetails': WheelDetailsToJSON(value['wheelDetails']),
        'game': S2WGameToJSON(value['game']),
        'id': value['id'],
    };
}

